module.exports = __webpack_public_path__ + "static/media/share.342f5285.png";